import styles from './TradingHistoryRevamp.module.css';
import { useNumberFormat } from '../../../hooks/useNumberFormat';

type TProps = {
  displayAmount?: number | null;
  maxTermLength?: number | null;
  isEstimatedAmountSmaller: boolean;
};
const LoanSummaryRevamp = ({
  displayAmount,
  maxTermLength,
  isEstimatedAmountSmaller,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <div className={styles.infoBanner}>
      <div className={styles.infoHeader}>
        <div className={styles.infoItem}>
          <p className={styles.label}>
            {isEstimatedAmountSmaller
              ? 'Requested amount:'
              : 'Estimated amount:'}
          </p>
          <p>{formatCurrency(displayAmount)}*</p>
        </div>

        <div className={styles.divider}>|</div>
        <div className={styles.infoItem}>
          <p className={styles.label}>Max term length:</p>
          <p>{maxTermLength} months</p>
        </div>
      </div>
      <p className={styles.infoText}>
        Submit key documents for a decision within one business day. No impact
        on credit score. Loan amount may change based on information provided,
        and approval not guaranteed.
      </p>
      <p className={styles.infoDisclaimer}>
        *This is an estimated amount. Final terms are subject to the strength of
        your application.
      </p>
    </div>
  );
};

export default LoanSummaryRevamp;
